import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { Header } from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { Footer } from "../../components/Footer";

export const NotFoundPage = () => {
  const nav = useNavigate();
  return (
    <div className="not-found">
      <Header mode="dark" defaltNav={true} />
      <div className="not-found-box">
        <div>
          <div className="picture">
            <img
              src={"//files.authing.co/authing-website/authing-404.svg"}
              alt="authing error"
            />
          </div>
          <div className="text">
            Error，页面出错啦！请点击返回首页或者刷新页面～
          </div>
          <div className="button-warp">
            <Button
              mode="middleLight"
              onClick={() => {
                window.history.back();
              }}
            >
              返回上一页
            </Button>
            <Button
              onClick={() => {
                nav("/");
              }}
            >
              返回首页
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
